import { render } from "./CollapsibleItem.vue?vue&type=template&id=717e94c6&scoped=true"
import script from "./CollapsibleItem.vue?vue&type=script&lang=js"
export * from "./CollapsibleItem.vue?vue&type=script&lang=js"

import "./CollapsibleItem.vue?vue&type=style&index=0&id=717e94c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717e94c6"]])

export default __exports__